module.exports = __webpack_public_path__ + "img/close-menu.7613b747.svg";